// ============================================================
// Argyle Consulting — Design System Tokens
// Source of truth for the new visual identity (navy + amber).
// Derived from the approved Brand Style Sheet.
// ============================================================

export const colors = {
  // Core brand
  navyInk: "#0E1B2A", // primary text, deepest backgrounds
  brandNavy: "#14263B", // headings, dark UI, logo wordmark
  steelBlue: "#2C6CA8", // secondary accent, links, eyebrows
  amber: "#F2791C", // primary accent, CTAs, highlights
  amberLight: "#FBB13C", // gradient start / accent dot
  amberDot: "#F6A623", // wordmark dot

  // Neutrals & UI
  canvas: "#F5F7FA",
  surface: "#FFFFFF",
  line: "#E4E9F0",
  lineSoft: "#E9EDF2",
  mutedText: "#5C6B7C",
  subtleText: "#9AA6B2",
  success: "#22A55B",

  // Footer / dark-section neutrals
  footerText: "#B6C6D6",
  footerMuted: "#8FA3B8",
  footerLabel: "#7E91A6",
  footerCopy: "#6E8298",
};

export const gradients = {
  amber: "linear-gradient(135deg,#FBB13C,#F2791C)",
  navy: "linear-gradient(160deg,#1E3A57,#0E1B2A)",
  footer: "linear-gradient(160deg,#13243A,#0A1422)",
};

export const fonts = {
  display: "'Bricolage Grotesque', system-ui, sans-serif", // headings, wordmark, stats, eyebrows, numbers
  body: "'Hanken Grotesk', system-ui, sans-serif", // body, nav, buttons, forms
};

export const radii = {
  card: "22px",
  pill: "40px",
  chip: "12px",
};

export const shadows = {
  card: "0 18px 40px -24px rgba(20,38,59,.25)",
  amberBtn: "0 10px 26px -12px rgba(242,121,28,.7)",
};

export const layout = {
  maxWidth: "1240px",
  pagePad: { xs: "20px", sm: "28px", md: "28px" },
  headerHeight: 68,
};

// ---- Reusable style fragments (MUI sx) ----

export const eyebrowSx = {
  fontFamily: fonts.display,
  fontSize: "12px",
  fontWeight: 600,
  letterSpacing: ".2em",
  textTransform: "uppercase",
  color: colors.steelBlue,
};

export const amberButtonSx = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "8px",
  background: gradients.amber,
  color: "#fff",
  fontFamily: fonts.body,
  fontWeight: 700,
  borderRadius: radii.pill,
  boxShadow: shadows.amberBtn,
  textTransform: "none",
  transition: "transform .25s ease, box-shadow .25s ease",
  "&:hover": {
    background: gradients.amber,
    transform: "translateY(-1px)",
    boxShadow: "0 14px 30px -10px rgba(242,121,28,.75)",
  },
};

export const lightCardSx = {
  backgroundColor: colors.surface,
  border: `1px solid ${colors.lineSoft}`,
  borderRadius: radii.card,
  boxShadow: shadows.card,
};

export const sectionWrapSx = {
  maxWidth: layout.maxWidth,
  mx: "auto",
  px: layout.pagePad,
  boxSizing: "border-box",
};

const tokens = { colors, gradients, fonts, radii, shadows, layout };
export default tokens;
